import {Ref} from 'vue';
import {Vector2, Vector3, Vector4} from 'three';
import {PolyDictionary} from '../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {AttribType, AttribSize} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Constant';
import {ColDefsArray} from './Common';
import {CoreEntity} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/CoreEntity';

interface SetupBuildTableOptions {
	header_names: Ref<ColDefsArray>;
	rowData: Ref<PolyDictionary<number>[]>;
}

export function SetupBuildTable(options: SetupBuildTableOptions) {
	const {header_names, rowData} = options;

	function buildHeaders(
		attrib_names: string[],
		attrib_sizes_by_name: PolyDictionary<AttribSize>,
		attrib_types_by_name: PolyDictionary<AttribType>
	) {
		// console.log('headers', attrib_names, attrib_sizes_by_name, attrib_types_by_name);
		// const points = core_group.points();
		// const position_name = 'position';

		// header
		header_names.value = [];
		header_names.value.push({
			headerName: '',
			field: 'index',
			pinned: 'left',
			type: 'indexColumn',
		});
		// header_names.value.push({
		// 	headerName: position_name,
		// 	children: [
		// 		{headerName: 'x', field: 'P_x', type: 'numericColumn'},
		// 		{headerName: 'y', field: 'P_y', type: 'numericColumn'},
		// 		{headerName: 'z', field: 'P_z', type: 'numericColumn'},
		// 	],
		// });

		const sorted_attrib_names = attrib_names.sort();
		for (let i = 0; i < sorted_attrib_names.length; i++) {
			const attrib_name = sorted_attrib_names[i];
			const attrib_type = attrib_types_by_name[attrib_name];
			const column_type = attrib_type === AttribType.NUMERIC ? 'numericColumn' : '';

			// if (attrib_name !== position_name) {
			const attrib_size = attrib_sizes_by_name[attrib_name];
			switch (attrib_size) {
				case AttribSize.FLOAT:
					header_names.value.push({
						headerName: attrib_name,
						field: `${attrib_name}_x`,
						type: column_type,
					});
					break;
				case AttribSize.VECTOR2:
					header_names.value.push({
						headerName: attrib_name,
						children: ['x', 'y'].map((c) => ({
							headerName: c,
							field: `${attrib_name}_${c}`,
							type: column_type,
						})),
					});
					break;
				case AttribSize.VECTOR3:
					header_names.value.push({
						headerName: attrib_name,
						children: ['x', 'y', 'z'].map((c) => ({
							headerName: c,
							field: `${attrib_name}_${c}`,
							type: column_type,
						})),
					});
					break;
				case AttribSize.VECTOR4:
					header_names.value.push({
						headerName: attrib_name,
						children: ['x', 'y', 'z', 'w'].map((c) => ({
							headerName: c,
							field: `${attrib_name}_${c}`,
							type: column_type,
						})),
					});
					break;
			}
			// }
		}
	}

	// const position_name = 'position';
	function buildTableData(
		entities: CoreEntity[],
		attribNames: string[],
		attrib_sizes_by_name: PolyDictionary<AttribSize>
	) {
		// table data
		const attributeValues = entities.map((entity, i) => {
			const entityAttributeValues: PolyDictionary<number> = {
				index: i,
				// P_x: position.x,
				// P_y: position.y,
				// P_z: position.z,
			};

			attribNames.forEach((attribName, i) => {
				// if (attrib_name !== position_name) {
				const attrib_size = attrib_sizes_by_name[attribName];
				const value = entity.attribValue(attribName);
				if (value == null) {
					return;
				}
				switch (attrib_size) {
					case AttribSize.FLOAT:
						entityAttributeValues[`${attribName}_x`] = value as number;
						break;
					case AttribSize.VECTOR2:
						entityAttributeValues[`${attribName}_x`] = (value as Vector2).x;
						entityAttributeValues[`${attribName}_y`] = (value as Vector2).y;
						break;
					case AttribSize.VECTOR3:
						entityAttributeValues[`${attribName}_x`] = (value as Vector3).x;
						entityAttributeValues[`${attribName}_y`] = (value as Vector3).y;
						entityAttributeValues[`${attribName}_z`] = (value as Vector3).z;
						break;

					case AttribSize.VECTOR4:
						entityAttributeValues[`${attribName}_x`] = (value as Vector4).x;
						entityAttributeValues[`${attribName}_y`] = (value as Vector4).y;
						entityAttributeValues[`${attribName}_z`] = (value as Vector4).z;
						entityAttributeValues[`${attribName}_w`] = (value as Vector4).w;
						break;
				}
			});

			return entityAttributeValues;
		});
		for (let i = 0; i < attributeValues.length; i++) {
			const row = attributeValues[i];
			rowData.value.splice(i, 1, row);
		}
	}

	return {
		buildHeaders,
		buildTableData,
	};
}
